import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const LoadDropIcon = createSvgIcon(
  'LoadDropIcon',
  <>
    <path
      d="M108.7 11.01C110.633 11.01 112.2 9.44301 112.2 7.51001C112.2 5.57701 110.633 4.01001 108.7 4.01001C106.767 4.01001 105.2 5.57701 105.2 7.51001C105.2 9.44301 106.767 11.01 108.7 11.01Z"
      stroke={ColorDynamic.Yellow300}
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M241.2 62.19L231.06 59.97"
      stroke={ColorDynamic.Blue200}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M237.24 56.01L235.02 66.15"
      stroke={ColorDynamic.Blue200}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M33.7799 49.8L32.6299 58.21"
      stroke={ColorDynamic.Silver500}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M29 53.43L37.41 54.58"
      stroke={ColorDynamic.Silver500}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M54.2 30.94C54.2 26.28 57.45 22.5 61.47 22.5V98.5C57.46 98.5 54.2 94.72 54.2 90.06V30.94Z"
      fill={ColorDynamic.Blue200}
    />
    <path
      d="M145.5 22.5H61.7C57.28 22.5 53.7 26.06 53.7 30.45V91.05C53.7 95.44 57.28 99 61.7 99H207.7C212.12 99 215.7 95.44 215.7 91.05V30.45C215.7 26.06 212.12 22.5 207.7 22.5H199.803"
      stroke={ColorDynamic.Silver500}
      strokeWidth="2"
    />
    <path
      d="M75.7498 70.53V85.2"
      stroke={ColorDynamic.Silver500}
      strokeWidth="0.75"
      strokeDasharray="2 2"
    />
    <path
      d="M75.7 89.9C78.1852 89.9 80.2 87.8853 80.2 85.4C80.2 82.9147 78.1852 80.9 75.7 80.9C73.2147 80.9 71.2 82.9147 71.2 85.4C71.2 87.8853 73.2147 89.9 75.7 89.9Z"
      fill={ColorDynamic.Green300}
    />
    <path
      d="M75.7 74.58C78.1852 74.58 80.2 72.5652 80.2 70.08C80.2 67.5947 78.1852 65.58 75.7 65.58C73.2147 65.58 71.2 67.5947 71.2 70.08C71.2 72.5652 73.2147 74.58 75.7 74.58Z"
      fill={ColorDynamic.Yellow300}
    />
    <path
      d="M150.79 72.24H87.7099C87.1099 72.24 86.6199 71.75 86.6199 71.16V69C86.6199 68.41 87.1099 67.92 87.7099 67.92H150.8C151.4 67.92 151.89 68.41 151.89 69V71.16C151.88 71.75 151.39 72.24 150.79 72.24Z"
      fill={ColorDynamic.Silver500}
    />
    <path
      d="M134.79 51.24H71.7099C71.1099 51.24 70.6199 50.75 70.6199 50.16V48C70.6199 47.41 71.1099 46.92 71.7099 46.92H134.8C135.4 46.92 135.89 47.41 135.89 48V50.16C135.88 50.75 135.39 51.24 134.79 51.24Z"
      fill={ColorDynamic.Silver500}
    />
    <path
      d="M104.79 38.24H71.7099C71.1099 38.24 70.6199 37.75 70.6199 37.16V35C70.6199 34.41 71.1099 33.92 71.7099 33.92H104.8C105.4 33.92 105.89 34.41 105.89 35V37.16C105.88 37.75 105.39 38.24 104.79 38.24Z"
      fill={ColorDynamic.Silver400}
    />
    <path
      d="M130.79 87.24H87.7099C87.1099 87.24 86.6199 86.75 86.6199 86.16V84C86.6199 83.41 87.1099 82.92 87.7099 82.92H130.8C131.4 82.92 131.89 83.41 131.89 84V86.16C131.88 86.75 131.39 87.24 130.79 87.24Z"
      fill={ColorDynamic.Silver400}
    />
    <path
      d="M203.79 87.24H138.7C138.1 87.24 137.61 86.75 137.61 86.16V84C137.61 83.41 138.1 82.92 138.7 82.92H203.79C204.39 82.92 204.88 83.41 204.88 84V86.16C204.88 86.75 204.39 87.24 203.79 87.24Z"
      fill={ColorDynamic.Silver500}
    />
    <path
      d="M203.79 72.24H158.7C158.1 72.24 157.61 71.75 157.61 71.16V69C157.61 68.41 158.1 67.92 158.7 67.92H203.79C204.39 67.92 204.88 68.41 204.88 69V71.16C204.88 71.75 204.39 72.24 203.79 72.24Z"
      fill={ColorDynamic.Silver400}
    />
    <path
      d="M172.705 47C185.681 47 196.2 36.4809 196.2 23.505C196.2 10.5291 185.681 0.0100098 172.705 0.0100098C159.729 0.0100098 149.21 10.5291 149.21 23.505C149.21 36.4809 159.729 47 172.705 47Z"
      fill={ColorDynamic.Blue100}
    />
    <path
      d="M181.769 24.2731L180.395 32.6319L163.678 29.8938L165.051 21.535L162.665 21.1465L161.292 29.5053C161.075 30.8156 161.979 32.0716 163.289 32.2885L180.007 35.0266C181.317 35.2435 182.573 34.3398 182.79 33.0295L184.163 24.6707L181.769 24.2731ZM174.476 23.8936L178.073 21.3182L179.482 23.2791L172.524 28.2763L167.536 21.3272L169.497 19.9175L172.082 23.505L173.979 11.9563L176.365 12.3449L174.476 23.8936Z"
      fill={ColorDynamic.White}
    />
  </>,
  { viewBox: '0 0 270 100', style: { width: 270, height: 100, fill: 'none' } },
);
